import { RiArrowGoBackLine } from '@remixicon/react';
import styles from './Retry.module.css';

const Retry = () => {
  return (
    <span className={styles.retry}>
      <RiArrowGoBackLine size={20} color='#0000C9' /> Retry
    </span>
  );
};

Retry.displayName = 'Retry';

export default Retry;
